import { omrehBaseClient } from "./client";

const CreateFirstGroupRequests = (data) => {
  return omrehBaseClient.post('/GuestRequest/CreateFirstGroupRequests', {
    "guestGroupID": data.guestGroupID,
    "startTrip": data.startTrip,
    "endTrip": data.endTrip,
    "description": data.description,
    "servicesRequest": data.servicesRequest, //array
    "from": data.from,
    "to": data.to
  }
  )
}

const Add = (data) => {
  return omrehBaseClient.post('/GuestRequest', {
    "guestGroupID": data.guestGroupID,
    "guestServices": data.guestServices,
    "guestServiceType": data.guestServiceType,
    "cityConsistency": data.cityConsistency,
    "hotelId": data.hotelId,
    "selectPassengersId": data.selectPassengersId, //arr
    "from": data.from,
    "to": data.to,
    "originStation": data.originStation,
    "destinationStation": data.destinationStation
  }
  )
}

const Delete = (id) => {
  return omrehBaseClient
    .delete("/GuestRequest", {
      params: {
        'Id': id
      }
    });
}

const DeleteMember = (id, passengerId) => {
  return omrehBaseClient.put("/GuestRequest/DeleteMember", null, {
    params: { Id: id, PassengerId: passengerId }
  });
}

const AddMember = (id, passengerId) => {
  return omrehBaseClient.put("/GuestRequest/AddMember", null, {
    params: { Id: id, PassengerId: passengerId }
  });
}

const Update = (id, data) => {
  return omrehBaseClient.put('/GuestRequest', {
    "from": data.from,
    "to": data.to,
    "originStation": data.originStation,
    "destinationStation": data.destinationStation
  }, {
    params: {
      'id': id
    }
  }
  )
}

const guestRequestApi = {
  CreateFirstGroupRequests, Delete, Add, DeleteMember, AddMember, Update
}

export default guestRequestApi